import {BaseSpringServiceCB} from '@aiknow-srl/aik-angular-sdk';
import {CustomerProductItemOPEEnum} from "./CustomerProductItemOPEEnum";
import {ProductType} from "../../Models/CustomerProductItem/ProductType";
import {CustomerProductItem} from "../../Models/CustomerProductItem/CustomerProductItem";
import {Charger} from "../Charger/Charger";

class DAEAttributesDTO {
  public daeIsMonitored = false;
  public daeSerialNumber?: string;
  public daeBatteryExpireDate?: Date;
  public daeElectrodeExpireDate?: Date;
}


class ChargerRelatioDTO {
  public chargerType!: Charger;
  public productItem!: CustomerProductItem;
  public id!: number;
  public taIndex!: number;
  public chargerCount!: number
}

class E015AttributesDTO {
  public providerName!: string;

  public stationId!: string;

  public locationAddressType!: string;

  public locationAddress!: string;

  public locationZipCode!: string;

  public locationCity!: string;

  public locationProvince!: string;

  public locationRegion!: string;

  public stationAccessibility!: string;

  public isAlwaysAvailable = true;

  public isFromSustainableEnergy = false;


}

/**
 * I inner class
 */
class I {
  public id!: string;
}

/**
 * O inner class
 */

class O {
  public id!: string;
  public name!: string;
  public label!: string;
  public registryStatus!: string;
  public customerId!: string;
  public latitude?: number;
  public longitude?: number;
  public location!: string;
  public serialNumber!: string;
  public productType!: ProductType;
  public hasDae!: boolean;
  public useChirpstack!: boolean;
  public devEui?: string;
  public hasOsmUrl!: boolean;
  public osmUrl?: string;
  public isE015!: boolean;
  public note?: string;
  public imageUrl?: string;

  public isMonitored!: boolean
  public daeAttributes!: DAEAttributesDTO;
  public e015Attributes!: E015AttributesDTO;

  public chargers!: ChargerRelatioDTO[];
  public allChargers?: Charger[];

  constructor() {
    this.chargers = new Array<ChargerRelatioDTO>();

  }
}


/**
 * put reseller class
 */

export class GetCustomerProductItemAttributesCB extends BaseSpringServiceCB {

  /**
   * I
   */
  public i: I;


  /**   * O
   */
  public o: O;


  /**
   * constructor
   */
  constructor(){
    super(CustomerProductItemOPEEnum.GetCustomerProductItemAttributes);
    this.i = new I();
    this.o = new O();
  }

}
